/** Live-page spotlight steps for Time Tracker (field + admin). */

export const TT_FIELD_INTERACTIVE_STEPS = [
  {
    id: 'welcome',
    title: 'Walk the real page',
    content: 'This is not a cartoon. We will point at the real buttons on Time Tracker. Click Next and we will hop around the toolbar.',
    target: null,
  },
  {
    id: 'help',
    title: 'Help is always here',
    content: 'The teal Help button opens the written guide, the video tour, and this interactive walk. You can come back anytime.',
    target: '[data-tt-tour="help"]',
  },
  {
    id: 'search',
    title: 'Find a person or a job',
    content: 'Type a name, employee code, or job like PRESO-TT-001. The grid filters as you type.',
    target: '[data-tt-tour="search"]',
  },
  {
    id: 'daily',
    title: 'Daily — crew heads',
    content: 'One date, the whole crew. Only works if you are a crew head. Foremen, general foremen, and superintendents enter time here.',
    target: '[data-tt-tour="daily"]',
  },
  {
    id: 'weekly',
    title: 'Weekly — one person',
    content: 'Project managers, accounting, and superadmin see this button. One person for the week. Hours auto-save as draft until you submit. Field supervision uses Daily instead.',
    target: '[data-tt-tour="weekly"]',
  },
  {
    id: 'analytics',
    title: 'Analytics is a picture',
    content: 'Charts of hours by trade, code, and week. It is not payroll. Use it to spot a weird spike before you lock the week.',
    target: '[data-tt-tour="analytics"]',
  },
  {
    id: 'crews',
    title: 'Crews (if you can see it)',
    content: 'Anyone can create the crew they head, change it, and transfer it. Accounting can change any crew. Every change is written to Audit.',
    target: '[data-tt-tour="crews"]',
  },
  {
    id: 'admin',
    title: 'Admin (clerks only)',
    content: 'Op Codes, Extras, Employees, Reports, Period Lock, Maestro. If you do not see this button, that is permission, not a broken page.',
    target: '[data-tt-tour="admin"]',
  },
];

export const TT_ADMIN_INTERACTIVE_STEPS = [
  {
    id: 'admin-home',
    title: 'Six cards, one job each',
    content: 'Open a card only when you need that job. Most weeks: codes, extras, lock, then Maestro.',
    target: '[data-tt-tour="admin-home"]',
  },
  {
    id: 'opcodes',
    title: 'Op Codes',
    content: 'Load the standard labour list for a job-discipline. Empty timesheet dropdown means this list was never saved.',
    target: '[data-tt-tour="admin-opcodes"]',
  },
  {
    id: 'extras',
    title: 'Extras',
    content: 'Change Log creates the extra number. This card turns it on or off for timesheets. Look for the amber Change Log badge.',
    target: '[data-tt-tour="admin-extras"]',
  },
  {
    id: 'employees',
    title: 'Employees',
    content: 'Same master as Hiring / Layoff. Entra is a different circle (office logins), not a filter on this list.',
    target: '[data-tt-tour="admin-employees"]',
  },
  {
    id: 'reports',
    title: 'PDF reports',
    content: 'Details, Master Payroll, OP Code Summary, Contract. Submitted hours only.',
    target: '[data-tt-tour="admin-reports"]',
  },
  {
    id: 'periods',
    title: 'Period lock',
    content: 'Locking Canada freezes that week for every Canadian employee, on every job. A person with no payroll group is not covered.',
    target: '[data-tt-tour="admin-periods"]',
  },
  {
    id: 'maestro',
    title: 'Maestro export',
    content: 'Nine lines per person, job, code, and shift. Zero lines are skipped. Drafts are included. Removed rows and PRESO-TT-001 are not. Submit drafts first so this matches the PDF.',
    target: '[data-tt-tour="admin-maestro"]',
  },
];
